import axios from 'axios'

export default class EmailService {
    static SendEmail(name, address, message) {
        return axios.post('/sendmail.php', {
            name: name,
            mail: address,
            message: message
        });
    }
}